<template>
  <div class="display">
    <div class="f-tar">
      <Button @click="$router.push('/host/index/audit/list')">返回</Button>
    </div>
    <div v-if="info">
      <div class="item">
        <div class="item-l">提交时间：</div>
        <div class="item-r">{{ info.changeTime | moment("YYYY/MM/DD HH:mm:ss")}}</div>
      </div>
      <div class="item">
        <div class="item-l">审核状态：</div>
        <div class="item-r">
          <span v-if="info.status === 0" style="color: red;">尚未审核</span>
          <span v-if="info.status === 1" style="color: blue;">审核通过</span>
          <span v-if="info.status === -1" style="color: red;">审核未通过</span>
        </div>
      </div> 
      <div class="item">
        <div class="item-l">公司中文名：</div>
        <div class="item-r" :class="{editMode:  (info.original && info.original.compName !== info.compName)}">{{ info.compName || 'N/A'}}</div>
      </div> 
      <div class="item">
        <div class="item-l">公司英文名：</div>
        <div class="item-r" :class="{editMode:  (info.original && info.original.compNameEn !== info.compNameEn)}">{{ info.compNameEn || 'N/A'}}</div>
      </div> 
    </div>
    <div class="f-tac" v-if="info && info.status !== 1">
      <Button @click="pass" style="margin: 0 10px;" type="primary">通过审核</Button>
      <Button @click="unpass" style="margin: 0 10px;" type="primary">不通过</Button>
    </div>
    <div class="f-tac" v-if="info && (info.status === 1 && info.syncStatus === 2)">
      <Button @click="asyncHandle">重新同步</Button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"; 
export default {
  name: "host-audit-info-invoice",
  data() {
    return {  
      query: null,
      info: null,   
    };
  },
  created() {
    this.query = this.$route.query;
    this.init();
  }, 
  computed: {},
  methods: {
    ...mapActions({ 
      getLintelDownByRecord: "hostAuditModule/getLintelDownByRecord",
      editLintelDownAudit: "hostAuditModule/editLintelDownAudit",
      reSync: "hostAuditModule/reSync"
    }),
    async init() {
      this.info = await this.getLintelDownByRecord(this.$route.query.id); 
      
    },
    async pass() {
      console.log(this.info.recordId)
      // 通过审核
      const opt = {
        id: this.info.recordId,
        status: 1
      };
      const bool = await this.editLintelDownAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        // this.$router.push("/host/index/audit/list");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async unpass() {
      // 不通过审核
      const opt = {
        id: this.info.recordId,
        status: -1
      };
      const bool = await this.editLintelDownAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        // this.$router.push("/host/index/audit/list");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async asyncHandle() {
      // 重新同步 
      const bool = await this.reSync({exchangeId: this.info.exchangeId});
      if (bool && bool.successed) {
        this.$Message.success("操作成功"); 
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.display {
  padding: 20px 40px 40px;
  font-size: 14px;
  background: #fff;
  margin: 30px;
  color: #333;
  min-width: 800px;
  mim-height: 500px;
  .item {
    display: flex;
    margin-bottom: 18px;
    &-l {
      width: 200px;
      text-align: right;
    }
    &-r {
      flex: 1;
    }
  }
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
.editMode {
  color: red !important;
}
.edit {
  border-color: red !important;
}
</style>
